import { Flex } from '@chakra-ui/react';
import useIsSharedPage from '~/hooks/useIsSharedPage';
import { ExportPdfButton } from '~/screens/MediaPackDetailDefaultScreen/components/ExportPdfButton';
import { NavBarProps } from '~/screens/MediaPackDetailDefaultScreen/components/NavBar/MediaPackNavBar.model';
import { CreatorType } from '~/types';

import { blackButtonStyles, blackIconStyles } from './ButtonsSection.styles';
import { ContactButton } from './components/ContactButton';
import { ShareButton } from './components/ShareButton';

type Props = Omit<NavBarProps, 'activeSection'> & {
  creator: CreatorType;
  onShare: () => void;
};

export const ButtonsSection: React.FC<Props> = ({
  mediaPack,
  creatorBenchmarks,
  creator,
  creatorInsights,
  pdfImages,
  isSharedView,
  onShare,
}) => {
  const isSharedPage = useIsSharedPage();

  let shouldDisplayShareButton = true;

  if (isSharedPage) {
    shouldDisplayShareButton = false;
  }

  return (
    <Flex alignItems="center">
      {shouldDisplayShareButton && (
        <ShareButton onClick={onShare} {...blackButtonStyles} />
      )}
      <ExportPdfButton
        iconProps={blackIconStyles}
        data={{
          creator,
          creatorBenchmarks,
          creatorInsights,
          mediaPack,
          pdfImages,
        }}
        isSharedView={isSharedView}
        {...blackButtonStyles}
      />
      <ContactButton
        size="sm"
        email={mediaPack?.email || creator?.manager?.email || creator?.email}
      />
    </Flex>
  );
};
